import zxcvbn from 'zxcvbn'
import { suggestionsDE, warningsDE } from '~/plugins/vee-validate'
import { defineRule } from 'vee-validate';

export const translateZxcvbnFeedback = (feedback: zxcvbn.ZXCVBNFeedback): string => {
  const warningDE = warningsDE[feedback.warning] || ''
  const suggestionDE = feedback.suggestions
    .map(s => suggestionsDE[s] || s)
    .join(' ')

  return [warningDE, suggestionDE].filter(Boolean).join(' ')
}

export const useZxcvbn = () => {
  defineRule('password', (value: string) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }

    const result = zxcvbn(value)

    if (result.score < 3) {
      return translateZxcvbnFeedback(result.feedback) || 'Das Passwort ist zu schwach.'
    }

    return true
  });
  return { translateZxcvbnFeedback, zxcvbn }
}
